export default "__VITE_ASSET__8c23d381__"